import { ArrowUpRight, PhoneCall } from 'lucide-react';
import workingconstructor from '@/assets/constructorworking.jpg';
import { useNavigate } from 'react-router-dom';

export const AboutUS = () => {
  //console.log('test test');
  const pillars = [
    {
      icon: '/qualityworkmanship.webp',
      title: 'Quality Workmanship',
      desc: 'We use premium materials and proven methods to ensure durable, long-lasting results.',
    },
    {
      icon: '/trust.jpg',
      title: 'Transparency & Trust',
      desc: 'Clear communication, honest pricing and no hidden surprises.',
    },
    {
      icon: '/satisfaction.webp',
      title: 'Customer Satisfaction',
      desc: 'Your peace of mind is our top priority — we don’t leave until you’re happy.',
    },
  ];
  const services = [
    {
      icon: '/maintenance.png',
      title: 'Building Maintenance',
      link: '/building-maintenance',
      desc: 'Comprehensive maintenance to ensure your property remains in top condition.',
    },
    {
      icon: '/smallrepair.png',
      title: 'Small Repairs',
      link: '/small-repairs',
      desc: 'Quick and efficient repair solutions for minor damages and fixes.',
    },
    {
      icon: '/refurbish.png',
      title: 'Refurbishment of Flats',
      link: '/flat-refurbishment',
      desc: 'Complete refurbishment services to modernize and upgrade flats.',
    },
    {
      icon: '/painting.png',
      title: 'Painting',
      link: '/painting-services',
      desc: 'Interior and exterior painting with high-quality finishes.',
    },
    {
      icon: '/plumbing.png',
      title: 'Plumbing',
      link: '/plumbing-services',
      desc: 'Professional plumbing services for installations, leaks, and repairs.',
    },
    {
      icon: '/electricalwork.png',
      title: 'Electrical Works',
      link: '/electrical-works',
      desc: 'Safe and reliable electrical installations and maintenance.',
    },
    {
      icon: '/gardening.png',
      title: 'Gardening',
      link: 'gardening-services',
      desc: 'Garden maintenance and beautification for your outdoor spaces.',
    },
    {
      icon: '/roofing.png',
      title: 'Roofing',
      link: '/roofing-services',
      desc: 'Durable and weatherproof roofing installation and repair services.',
    },
    {
      icon: '/cleaning.png',
      title: 'Cleaning',
      link: '/cleaning-services',
      desc: 'Professional cleaning services for residential and commercial properties.',
    },
    {
      icon: '/carpet.png',
      title: 'Carpets and Flooring',
      link: '/flooring-services',
      desc: 'Installation and restoration of all types of flooring and carpets.',
    },
    {
      icon: '/homeextension.png',
      title: 'Home Extensions',
      link: '/home-extensions',
      desc: 'Expand your home with seamless and stylish extensions.',
    },
    {
      icon: '/kitchenfitting.png',
      title: 'Kitchen Fittings',
      link: '/kitchen-fitting-services',
      desc: 'Custom kitchen fitting services with attention to detail.',
    },
    {
      icon: '/bath.png',
      title: 'Bathroom Fittings',
      link: '/bathroom-fittings',
      desc: 'Elegant and functional bathroom installation and design.',
    },
    {
      icon: '/tiling.png',
      title: 'Tiling',
      link: '/tiling-services',
      desc: 'Expert tiling for walls, floors, and decorative finishes.',
    },
    {
      icon: '/groundwork.png',
      title: 'Ground Works',
      link: '/groundwork-services',
      desc: 'Reliable groundwork solutions to prepare for any construction project.',
    },
    {
      icon: '/landscaping.png',
      link: '/landscaping-service',
      title: 'Gardening & Landscaping',
      desc: 'Transform outdoor areas with creative landscaping and garden design.',
    },
  ];
  let navigate = useNavigate();
  return (
    <>
      <div className="mt-[9rem] flex w-full justify-center bg-[white] py-[4rem] font-inter">
        <div className="flex w-full max-w-[144rem] flex-row flex-wrap items-stretch justify-center gap-x-[4rem] gap-y-[3rem] px-[2rem]">
          <div className="flex w-full flex-wrap items-start gap-[2rem] md:w-[50%]">
            <div className="w-full">
              <h1 className="hidden text-[3.2rem] font-[700] leading-[4rem] text-[#121212] md:block lg:text-[4rem] lg:leading-[5.5rem]">
                About KU Contractors Limited
              </h1>
              <h1 className="text-center text-[2.4rem] font-[700] leading-[3.2rem] text-[#121212] md:hidden lg:text-[4rem] lg:leading-[5.5rem]">
                About KU Contractors Limited
              </h1>

              <p className="mt-[2rem] text-[1.6rem] font-[400] leading-[2.6rem] text-[#666666] md:leading-[3rem]">
                At <strong>KU Contractors Limited</strong>, we believe that every property deserves
                quality care, craftsmanship, and commitment.
                <br /> Based in the UK, we provide a complete range of construction and property
                maintenance services for homes, flats, offices, and commercial spaces. From small
                repairs to large-scale refurbishments, our mission is to make every project smooth,
                reliable, and built to last.
                <br />
                <br /> With years of experience in the industry, our team of skilled tradespeople
                delivers exceptional results — on time, within budget, and always to the highest
                standards of safety and workmanship. We take pride in combining traditional values
                of honesty and hard work with modern construction techniques and premium-grade
                materials.
              </p>
              <div className="mt-[2rem] flex w-full flex-col gap-y-[1rem]">
                <div className="flex items-center justify-between gap-[1rem]">
                  <div className="flex h-[8rem] w-[8rem] items-center justify-center rounded-full border-[2px] border-[#e24e1f]">
                    <PhoneCall className="mt-[0.3rem] h-auto w-[4rem] text-[#e24e1f]" />
                  </div>
                  <div className="w-[calc(100%-10rem)]">
                    <p className="text-[1.6rem] font-[400] leading-[150%] text-[#121212]">
                      For immediate assistance or emergency repairs, <br />
                      call us anytime at &nbsp;
                      <strong>07454-926-222</strong>.
                    </p>
                    <div
                      onClick={() => {
                        navigate('/contact-us');
                      }}
                      className="mt-[1rem] flex cursor-pointer justify-start gap-[0.5rem]"
                    >
                      <h1 className="text-[1.6rem] font-[600] leading-[3.2rem] text-[#666666] underline">
                        Contact Us
                      </h1>
                      <ArrowUpRight className="inline-block h-auto w-[2rem] text-[#e24e1f] underline" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full max-w-[40rem] text-center md:w-[50%] md:text-start">
            <img
              alt="constructor working"
              className="h-full w-auto rounded-md object-cover"
              src={workingconstructor}
            />
          </div>
        </div>
      </div>

      {/* Services Section */}
      <div className="flex w-full justify-center bg-[white] py-[4rem] font-inter">
        <div className="flex w-full max-w-[144rem] flex-row flex-wrap items-stretch justify-center gap-x-[1rem] gap-y-[3rem] px-[2rem]">
          <div className="flex w-full flex-wrap items-start gap-[2rem]">
            <div className="w-full">
              <h1 className="w-full text-center text-[2.4rem] font-[700] leading-[3.2rem] text-[#121212] md:text-[3.2rem] md:leading-[4rem] lg:text-[4rem] lg:leading-[5.5rem]">
                What We Do
              </h1>
              <p className="mt-[1rem] w-full text-center text-[1.6rem] font-[400] text-[#666666]">
                We offer end-to-end maintenance and construction services designed to keep your
                property safe, efficient, and beautiful:
              </p>
            </div>

            {/* Service Cards */}
            <div className="mt-[2rem] grid w-full grid-cols-1 gap-[2rem] sm:grid-cols-2 md:mt-[3rem] md:grid-cols-3 lg:mt-[4rem] lg:grid-cols-4">
              {services.map((item, index) => (
                <div
                  key={index}
                  onClick={() => {
                    navigate(item.link);
                  }}
                  className="flex cursor-pointer flex-col items-center justify-start gap-3 rounded-xl border border-[#e5e5e5] bg-[#fafafa] p-6 text-center transition"
                >
                  <img
                    src={item.icon}
                    alt={item.title}
                    className="h-[5rem] w-[5rem] object-contain"
                  />
                  <h3 className="text-[1.8rem] font-semibold text-[#1C253C]">{item.title}</h3>
                  <p className="text-[1.4rem] text-[#555]">{item.desc}</p>
                </div>
              ))}
            </div>

            <div className="mt-[4rem] w-full">
              <h1 className="w-full text-center text-[2.4rem] font-[700] leading-[3.2rem] text-[#121212] md:text-[3.2rem] md:leading-[4rem] lg:text-[4rem] lg:leading-[5.5rem]">
                Our Promise
              </h1>
              <p className="mt-[1rem] w-full text-center text-[1.6rem] font-[400] text-[#666666]">
                Every project we take on — big or small — is built on three pillars that ensure
                quality, honesty, and satisfaction.
              </p>
            </div>
            <div className="mt-[3rem] grid w-full grid-cols-1 gap-[2rem] sm:grid-cols-2 md:grid-cols-3">
              {pillars.map((item, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center justify-start gap-3 rounded-xl border border-[#e5e5e5] bg-[#fafafa] p-8 text-center transition hover:scale-[1.02]"
                >
                  <img
                    src={item.icon}
                    alt={item.title}
                    className="h-[10rem] w-[10rem] rounded-full object-cover"
                  />
                  <h3 className="text-[1.8rem] font-semibold text-[#1C253C]">{item.title}</h3>
                  <p className="text-[1.6rem] font-[400] text-[#666666]">{item.desc}</p>
                </div>
              ))}
            </div>
            <div className="mt-[2rem] flex w-full flex-row justify-center gap-y-[1rem] lg:mt-[4rem]">
              <div className="flex w-full max-w-[80rem] items-center justify-between gap-[1rem]">
                <div className="flex h-[8rem] w-[8rem] items-center justify-center rounded-full border-[2px] border-[#e24e1f]">
                  <PhoneCall className="mt-[0.3rem] h-auto w-[4rem] text-[#e24e1f]" />
                </div>
                <div className="w-[calc(100%-10rem)]">
                  <p className="text-[2.4rem] font-[400] leading-[150%] text-[#121212]">
                    For immediate assistance or emergency repairs,
                    <br /> call us anytime at &nbsp;
                    <strong>07454-926-222</strong>.
                  </p>
                  <div
                    onClick={() => {
                      navigate('/contact-us');
                    }}
                    className="mt-[1rem] flex cursor-pointer justify-start gap-[0.5rem]"
                  >
                    <h1 className="text-[1.6rem] font-[600] leading-[3.2rem] text-[#666666] underline">
                      Contact Us
                    </h1>
                    <ArrowUpRight className="inline-block h-auto w-[2rem] text-[#e24e1f] underline" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
